import React from "react";
import { Box, Grid, TextField, Divider, Button, OutlinedInput, Checkbox, Tooltip, ListItemText, Stack } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useCallback, useMemo, useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import Logo from '../../../Media/Upload.jpeg';
import { useTranslation } from "react-i18next";
import InputAdornment from '@mui/material/InputAdornment';
import axios from "../../../utils/fvAxios";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import "../../../Localization/i18n";
import apiinfo from "../../../utils/base-uri.json";
import { ToastContainer, toast } from "react-toastify";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import InputMask from 'react-input-mask';

import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Trash from "../../../icons/trash1.svg";
import CloseIcon from '@mui/icons-material/Close';
import Replay from "../../../icons/Replay.svg";

export default function ClientEditBusinessInfo({ org }) {

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#bdbdbd",

    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 15,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
      marginBottom: "20px"
    },
  }));

  const toastNotify = (message, isSuccess = true) => {
    if (isSuccess) {
      toast.success(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const { t } = useTranslation();
  const [age, setAge] = React.useState("");
  const [year, setYear] = React.useState("");

  const handleChange = (event) => {
    setAge(event.target.value);
  };
  const handleChange1 = (event) => {
    setYear(event.target.value);
  };

  const activeStyle = {
    borderColor: '#2196f3'
  };

  const acceptStyle = {
    borderColor: '#00e676'
  };

  const rejectStyle = {
    borderColor: '#ff1744'
  };
  const {
    acceptedFiles,
    fileRejections,
    isDragActive,
    isDragAccept,
    isDragReject,
    getRootProps,
    getInputProps
  } = useDropzone({
    accept: {

      'image/png': []
    }
  });

  const style = useMemo(() => ({

    ...(isDragActive ? activeStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {})
  }), [
    isDragActive,
    isDragReject,
    isDragAccept
  ]);

  const acceptedFileItems = acceptedFiles.map(file => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  const fileRejectionItems = fileRejections.map(({ file, errors }) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
      <ul>
        {errors.map(e => (
          <li key={e.code}>{e.message}</li>
        ))}
      </ul>
    </li>
  ));
  const activeStyle2 = {
    borderColor: '#FFA500' // Example color
  };

  const acceptStyle2 = {
    borderColor: '#008000' // Example color
  };

  const rejectStyle2 = {
    borderColor: '#FF0000' // Example color
  };

  // Use the useDropzone hook for the second dropzone
  const {
    acceptedFiles: acceptedFiles2,
    fileRejections: fileRejections2,
    isDragActive: isDragActive2,
    isDragAccept: isDragAccept2,
    isDragReject: isDragReject2,
    getRootProps: getRootProps2,
    getInputProps: getInputProps2
  } = useDropzone({
    accept: {

      'image/png': []
    }
  });

  // Calculate the style for the second dropzone
  const style2 = useMemo(() => ({
    ...(isDragActive2 ? activeStyle2 : {}),
    ...(isDragAccept2 ? acceptStyle2 : {}),
    ...(isDragReject2 ? rejectStyle2 : {})
  }), [
    isDragActive2,
    isDragReject2,
    isDragAccept2
  ]);

  // Map over the accepted and rejected files for the second dropzone
  const acceptedFileItems2 = acceptedFiles2.map(file => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  const fileRejectionItems2 = fileRejections2.map(({ file, errors }) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
      <ul>
        {errors.map(e => (
          <li key={e.code}>{e.message}</li>
        ))}
      </ul>
    </li>
  ));



  const [editClient, setEditClient] = React.useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);



  const [name, setName] = useState('');
  const [tax, setTax] = useState('');
  const [PrincipalOfficerName, setPrincipalOfficerName] = useState('');
  const [City, setCity] = useState('');
  const [Zip, setZip] = useState('');
  const [Address, setAddress] = useState('');
  const [Address2, setAddress2] = useState('');
  const [Address3, setAddress3] = useState('');
  const [Telephone, setTelephone] = useState('');
  const [rawPhoneNumber, setRawPhoneNumber] = useState('');
  const [Phone, setPhone] = useState('');
  const [Fax, setFax] = useState('');
  const [url, setUrl] = useState('');
  const [state, setState] = useState('');
  const [registration, setRegistration] = useState('');
  const [SubClient, setSubClient] = useState('');
  const [country, setCountry] = useState('');
  const [accpectVendor, setAccpectVendor] = useState('');
  const [TrainingRequired, setTrainingRequired] = useState('');
  const [OtpRequired, setOtpRequired] = useState('');
  const [hourstoscheckout, setHourstoscheckout] = useState('');
  const [TrainingFeeCap, setTrainingFeeCap] = useState('');
  const [TrainingCertificate, setTrainingCertificate] = useState('');
  const [ExpirationPeriod, setExpirationPeriod] = useState('');
  const [RepresentativeName, setRepresentativeName] = useState('');
  const [RepresentativeEmail, setRepresentativeEmail] = useState('');
  const [InfusionSoftContactID, setInfusionSoftContactID] = useState('');
  const [ClientSecrte, setClientSecrte] = useState('');
  const [states, setStates] = useState([]);
  const [countries, setCountries] = useState([]);

  const [counrtyid, setCounrtyid] = useState("");
  const [stateid, setStateid] = useState("");
  const [TemplateList, setTemplateList] = useState([]);
  const [TemplateId, setTemplateId] = useState("");
  const [TemplateData, setTemplateData] = useState([]);
  const [ClientsList, setClientsList] = useState([]);




  useEffect(() => {
    axios.get("Companies/EditClient?orgId=" + org
    ).then((res) => {
      if (res.data.responseCode === 100) {
        const data = res.data.data.client;
        setChecked(data?.clients?.filter((client) => client.selected)?.map((client) => client.value));
        setEditClient(data);
        setClientsList(data?.clients)
        setName(data.name);
        setTax(data.taxID);
        setClientSecrte(data?.clientSecret);
        setPrincipalOfficerName(data.principalCompanyOfficerName);
        setCity(data.city);
        setZip(data.zip);
        setAddress(data.address1);
        setAddress2(data.address2);
        setAddress3(data.address3);
        setTelephone(data.phoneNumber);
        setPhone(data.extNumber);
        setFax(data.faxNumber);
        setUrl(data.websiteURL);
        setState(data.state);
        setRegistration(data.countryType);
        setSubClient(data.SubClient);
        setCountry(data.country);
        setAccpectVendor(data.acceptVendorsViaInvite);
        setTrainingRequired(data.trainingRequired);
        setHourstoscheckout(data.hoursToCheckout)
        setOtpRequired(data.isOtpcheckinRequired)
        setTrainingFeeCap(data.trainingFeeCap);
        setTrainingCertificate(data.trainingCertificate);
        setExpirationPeriod(data.ExpirationPeriod);
        setRepresentativeName(data.orgRepresentativeName);
        setRepresentativeEmail(data.orgRepresentativeEmail);
        setInfusionSoftContactID(data.orgInfusionSoftContactId);
        setCounrtyid(res?.data?.data?.client?.country);
        setStateid(res?.data?.data?.client?.state);
        setYear(data.contractorEvaluationExpirationPeriod);
        axios.get(apiinfo.addressInfo.getStateByRegion + "clientID=" + 0 + "&country=" + res?.data?.data?.client?.country)
          .then((res) => {
            if (res?.data?.responseCode === 100) {
              setStates(res?.data?.data)
            }
            else {
              setError(res?.data?.responseMessage);
            }
          }).catch(err => {
            console.log(err)
          });

        axios.get(apiinfo.addressInfo.getCountries)
          .then((res) => {
            if (res?.data?.responseCode === 100) {
              setCountries(res?.data?.data)
            }
            else {
              setError(res?.data?.responseMessage);
            }
          }).catch(err => {
            console.log(err)
          })

      }
      else {
        setError(res.data.responseMessage);
      }
    }).catch(err => {
      console.log(err)
    }).finally(() => {
      setIsLoading(false);
    });

    axios.get("Companies/GetTemplateDetails?organizationId=" + org
    ).then((res) => {
      if (res.data.responseCode === 100) {
        setTemplateList(res?.data?.data)
        setTemplateId(res?.data?.data[0]?.value);
      }
      else {
        setError(res.data.responseMessage);
      }
    }).catch(err => {
      console.log(err)
    }).finally(() => {
      setIsLoading(false);
    });

    axios.get("Companies/GetTemplateData?clientId=" + org
    ).then((res) => {
      if (res.data.responseCode === 100) {
        setTemplateData(res?.data?.data)
      }
      else {
        setError(res.data.responseMessage);
      }
    }).catch(err => {
      console.log(err)
    }).finally(() => {
      setIsLoading(false);
    });

  }, [refresh]);

  const getState = (e) => {
    if (e == "") {
      setError("please select country");
      setCounrtyid(e);
    } else {
      setError("");
      setCounrtyid(e);
      axios.get(apiinfo.addressInfo.getStateByRegion + "clientID=" + org + "&country=" + e)
        .then((res) => {
          if (res?.data?.responseCode === 100) {
            setStates(res?.data?.data)
          }
          else {
            setError(res?.data?.responseMessage);
          }
        }).catch(err => {
          console.log(err)
        })
    }
  }
  const [phoneError, setPhoneError] = useState(null);
  const [telephoneError, setTelephoneError] = useState(null);
  const [emailError, setEmailError] = useState(null);
  const [faxError, setFaxError] = useState(null);
  const validatePhoneNumber = (phoneNumber) => {
    const regex = /^\(\d{3}\) \d{3}-\d{4}$/;
    return regex.test(phoneNumber);
  };
  const validateNumber = (email) => {
    const regex = /^\(\d{3}\) \d{3}-\d{4}$/;
    return email === '' || regex.test(email);
  };

  const validateEmail = (email) => {
    const regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,20}$/;
    return email === '' || regex.test(email);
  };

  const handleInputChange = (event) => {

    const inputValue = event.target.value;
    const numericInput = inputValue.replace(/[^0-9]/g, '');

    if (numericInput.length <= 10) {
      if (numericInput === '') {
        // Field is empty, no error
        setTelephone('');
        setTelephoneError(true);
      } else if (/^\d{10}$/.test(numericInput)) {
        const formattedInput = `(${numericInput.slice(0, 3)}) ${numericInput.slice(3, 6)}-${numericInput.slice(6)}`;
        setTelephone(formattedInput);
        setTelephoneError(false);
      } else {
        setTelephone(numericInput);
        setTelephoneError(true);
      }
    } else {
      // Limit to 10 digits, no further input allowed
      setTelephone(numericInput.slice(0, 9));
      setTelephoneError(true);
    }
  };


  const handleSubmit = (event) => {

    event.preventDefault();
    if (!name || !Address || !Zip || !counrtyid || !Telephone || !stateid || !City) {
      toastNotify("Please fill all the mandatory fields", false);
    } else {
      setIsLoading(true);
      const formData = new FormData();
      formData.append('SingleClientCode', editClient?.singleClientCode == null ? "" : editClient?.singleClientCode);
      formData.append('CopyAnswers', 0);
      formData.append('QuestionarieTypeIdForPrequalRequirements', editClient?.questionarieTypeIdForPrequalRequirements == null ? "" : editClient?.questionarieTypeIdForPrequalRequirements);
      formData.append('FederalIDNumber', editClient?.federalIDNumber == null ? "" : editClient?.federalIDNumber);
      formData.append('Zip', Zip == null ? "" : Zip);
      formData.append('ContractorEvaluationExpirationPeriod', year == null ? "" : year);
      formData.append('OrgInfusionSoftContactId', InfusionSoftContactID == null ? "" : InfusionSoftContactID);
      formData.append('IntroContentStr', editClient?.introContentStr == null ? "" : editClient?.introContentStr);
      formData.append('isCompanyExist', editClient?.isCompanyExist == null ? "" : editClient?.isCompanyExist);
      formData.append('OrgnaizationPhoto', acceptedFiles2[0]);///////////////////////////////
      formData.append('TrainingFeeCap', TrainingFeeCap == null ? "" : TrainingFeeCap);
      formData.append('FaxNumber', Fax == null ? "" : Fax);
      formData.append('TaxID', tax);
      formData.append('LogoBlob', editClient?.logoBlob == null ? "" : editClient?.logoBlob);
      formData.append('QuestionarieTypeId', editClient?.questionarieTypeId == null ? "" : editClient?.questionarieTypeId);
      formData.append('MoodleTrainingRequired', editClient?.moodleTrainingRequired == null ? "" : editClient?.moodleTrainingRequired);
      formData.append('ExtNumber', Phone == null ? "" : Phone);
      formData.append('ConfirmDelete', editClient?.confirmDelete == null ? "" : editClient?.confirmDelete);
      formData.append('City', City == null ? "" : City);
      formData.append('Logo', editClient?.logo == null ? "" : editClient?.logo);
      formData.append('Name', name == null ? "" : name);
      formData.append('OrgRepresentativeName', RepresentativeName == null ? "" : RepresentativeName);
      formData.append('OrganizationType', editClient?.organizationType == null ? "" : editClient?.organizationType);
      formData.append('GeographicArea', []);
      formData.append('OrganizationID', org == null ? "" : org);
      formData.append('PhotoBlob', editClient?.photoBlob == null ? "" : editClient?.photoBlob);
      formData.append('CountryType', registration == null ? "" : registration);
      formData.append('State', stateid == null ? "" : stateid);
      formData.append('PrincipalCompanyOfficerName', editClient?.principalCompanyOfficerName);
      formData.append('Photo', editClient?.photo == null ? "" : editClient?.photo);
      formData.append('AcceptVendorsViaInvite', accpectVendor == null ? "" : accpectVendor);
      formData.append('WebsiteURL', url == null ? "" : url);
      formData.append('Country', counrtyid == null ? "" : counrtyid);
      formData.append('PhoneNumber', Telephone == null ? "" : Telephone);
      formData.append('FinancialMonth', "");
      formData.append('FinancialDate', "");
      formData.append('OrgnaizationLogo', acceptedFiles[0]);
      formData.append('Language', editClient?.language == null ? "" : editClient?.language);
      formData.append('TrainingRequired', TrainingRequired == null ? "" : TrainingRequired);
      formData.append('IsOtpcheckinRequired', OtpRequired == null ? "" : OtpRequired);
      formData.append('HoursToCheckout', hourstoscheckout == null ? "" : hourstoscheckout);
      formData.append('isSuccess', editClient?.isSuccess == null ? "" : editClient?.isSuccess);
      formData.append('OrgRepresentativeEmail', RepresentativeEmail == null ? "" : RepresentativeEmail);
      formData.append('EmployeeSelfRegistrationURL', editClient?.employeeSelfRegistrationURL == null ? "" : editClient?.employeeSelfRegistrationURL);
      formData.append('ClientSecrte', editClient?.clientSecrte == null ? "" : editClient?.clientSecrte);
      formData.append('TrainingCertificate', TrainingCertificate == null ? "" : TrainingCertificate);
      formData.append('Address1', Address == null ? "" : Address);
      formData.append('Address2', Address2 == null ? "" : Address2);
      formData.append('Address3', Address3 == null ? "" : Address3);
      // formData.append('Clients', ClientsList);
      formData.append('DisabledClients', checkedVAlue);

      ClientsList?.forEach((client, index) => {
        formData.append(`Clients[${index}][text]`, client.text);
        formData.append(`Clients[${index}][value]`, client.value);
        formData.append(`Clients[${index}][selected]`, checked.includes(client.value));
      });
      axios
        .post('Companies/SaveClient',
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        )
        .then((res) => {
          if (res?.data?.responseCode == "100") {
            toastNotify(res?.data?.responseMessage, true);
            setRefresh(!refresh);
          } else {
            toastNotify(res?.data?.responseMessage, false);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };


  const ChangeState = (e) => {
    setStateid(e);
  }

  // const initiallySelectedClients = editClient?.clients?.filter(client => client?.selected)?.map(client => client.value);
  // const [selectedClients, setSelectedClients] = React.useState(initiallySelectedClients);

  // const handleChange4 = (event) => {
  //   const {
  //     target: { value },
  //   } = event;
  //   setSelectedClients(value);
  // };
  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };
  const initialChecked = editClient?.clients?.filter((client) => client.selected)?.map((client) => client.value);

  const [checked, setChecked] = React.useState(initialChecked);
  const [checkedVAlue, setCheckValue] = React.useState();

  const handleToggle = (client) => () => {
    setCheckValue(client?.value);
    if (editClient?.disabledClients?.includes(client.value)) {
      return;
    }

    const currentIndex = checked?.indexOf(client.value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked?.push(client.value);
    } else {
      newChecked?.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };
  const [open, setOpen] = React.useState(false);
  const [tab, setTab] = React.useState("");
  const [ID, setID] = React.useState("");

  const handleClickOpen = (num, id) => {
    setTab(num);
    setID(num == 3 ? id : "");
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const Templates = (num) => {
    if (num == 1) {
      axios.post("Companies/DeleteTemplatekey?organizationId=" + org + "&templateId=" + ID)
        .then((res) => {
          if (res?.data) {
            toastNotify(res?.data?.responseMessage, true);
            handleClickOpen(1, "");
            setOpen(true);
            setRefresh(!refresh);
          } else {
            toastNotify(res?.data?.responseMessage, false);
          }
        })
        .catch((err) => {
          console.log(err);
        })
    } else {
      axios.get("Companies/UpdateTemplatekey?organizationId=" + org + "&templateId=" + TemplateId)
        .then((res) => {
          if (res?.data) {
            toastNotify(res?.data?.responseMessage, true);
            handleClickOpen(1, "");
            setRefresh(!refresh);
          } else {
            toastNotify(res?.data?.responseMessage, false);
          }
        })
        .catch((err) => {
          console.log(err);
        })

    }

  }

  const NewClientsecret = () => {
    axios.post("Companies/Updatekey?organizationId=" + org)
      .then((res) => {
        if (res?.data) {
          toastNotify(res?.data?.responseMessage, true);
          setClientSecrte(res?.data?.data);
        } else {
          toastNotify(res?.data?.responseMessage, false);
        }
      })
      .catch((err) => {
        console.log(err);
      })
  }
  // editClient?.clients?.sort((a, b) => a.value.localeCompare(b.value));
  // console.log(editClient?.clients);
  return (
    <>
      <div>

        <Dialog
          open={open}
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <Stack direction={"row"} spacing={"Auto"}>
            <DialogTitle> {name} </DialogTitle>
            <Button color="error" onClick={handleClose} sx={{ textTransform: "capitalize" }}><CloseIcon /></Button>
          </Stack>

          <div style={{ padding: "5px" }}>
            <Button variant="contained" sx={{ padding: "15px", float: "right" }} hidden={tab == 2 || tab == 3} onClick={() => handleClickOpen(2, "")} >Add</Button>
          </div>
          <DialogContent>
            {tab == 3 ? "Are you sure? you want to permanently delete this Key" : tab == 1 ?
              <Box sx={{ backgroundColor: '#f8f9fa' }}>
                <TableContainer component={Paper} sx={{ borderBottom: 0 }}>
                  <Table aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell ><span style={{ color: "rgb(14 14 15)", fontSize: "16px" }}> Template Name</span>	</StyledTableCell>
                        <StyledTableCell ><span style={{ color: "rgb(14 14 15)", fontSize: "16px" }}> Client Code</span></StyledTableCell>
                        <StyledTableCell >&nbsp;</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    {TemplateData?.map((r, i) => (
                      // <TableBody key={i}>
                      <TableRow key={i} >
                        <StyledTableCell sx={{ width: "Auto" }}>
                          {r?.templateName}
                        </StyledTableCell>
                        <StyledTableCell sx={{ width: "Auto" }} >
                          {r?.clientCode}
                        </StyledTableCell>
                        <StyledTableCell sx={{ width: "Auto" }}>
                          <IconButton aria-label="delete" onClick={() => handleClickOpen(3, r?.templateId)}>
                            <img src={Trash} alt="trashicon" />
                          </IconButton>
                        </StyledTableCell>
                      </TableRow>
                      // </TableBody>
                    ))}
                  </Table>
                </TableContainer>
              </Box >
              :
              <div className='mt-3'>
                <span style={{ color: "#3E4A62" }}>Template<span style={{ color: "red" }}>*</span></span>
                <br />
                <Select sx={{
                  width: "100%",
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  fontFamily: "Arial, FontAwesome",
                }}

                  size="small" value={TemplateId} onChange={(e) => setTemplateId(e?.target?.value)}>
                  {TemplateList?.map((option) => (
                    <MenuItem key={option?.value} value={option?.value}>
                      {option?.text}
                    </MenuItem>
                  ))}
                </Select>

              </div>
            }
          </DialogContent>
          <div hidden={tab == 1 || tab == 3}>
            <DialogActions>
              <Button variant="contained" sx={{ padding: "15px" }} onClick={() => Templates(2, "")} >Submit</Button>
            </DialogActions>
          </div>
          <div hidden={tab == 1 || tab == 2}>
            <DialogActions>
              <Button variant="contained" sx={{ padding: "15px" }} onClick={() => Templates(1, "")} >Ok</Button>
              <Button variant="contained" sx={{ padding: "15px" }} onClick={() => handleClickOpen(1, "")} >Cancel</Button>
            </DialogActions>
          </div>
        </Dialog >
      </div >

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ToastContainer />
      <Box>
        <Box
          border={1}
          borderLeft={1}
          borderRight={1}
          borderColor="#e4e7ec"
          className="mt-2"
          sx={{ background: "#fff" }}
        >
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "10px" }}
          >
            <Grid item xs={12} sm={4} md={4} >
              <p
                className="mt-2"
                style={{ fontSize: "500px", color: "#3E4A62", fontSize: "20px", fontWeight: "500", marginBottom: 0 }}
              >
                {t('ClientEditBusinessInfo.label1')}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}></Grid>
          </Grid>
          <hr hidden={!editClient?.clients} />
          <Grid
            hidden={!editClient?.clients}
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label2')}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              {/* <FormControl sx={{ m: 1, width: 300 }}>

                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                   multiple
                  value={selectedClients  || []}
                  onChange={handleChange4}
                  input={<OutlinedInput id="select-multiple-chip" label="Clients" />}
                  renderValue={(selected) => (
                    <Box sx={{ display: 'flex', gap: "2px", overflowX: "hidden" }}>

                      <span>{editClient?.clients?.find(client => client.value === selected[0])?.text}</span>

                      <div style={{ marginLeft: "auto" }}>       <Tooltip title={<Box >
                        {selected?.map((value) => {
                          const client = editClient?.clients?.find(client => client.value === value);
                          return (
                            <span key={client.value}  >{client.text} <br /></span>
                          );
                        })}
                      </Box>} arrow >
                        <span >+{selected.length - 1}</span>
                      </Tooltip>     </div>

                    </Box>
                  )}
                  MenuProps={MenuProps}
                >
                  {editClient?.clients?.map((client) => (
                    <MenuItem key={client.value} value={client.value} disabled={editClient?.disabledClients?.includes(client.value)}>
                      <Checkbox checked={selectedClients?.includes(client.value)} />
                      <ListItemText primary={client.text} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}
              <Box
                sx={{
                  border: '1px solid #ccc', // Border style
                  height: '200px', // Height set to 200px
                  overflowY: 'auto', // Enable vertical scroll if needed
                }}
              >
                <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                  {editClient?.clients?.sort((a, b) => a.text.localeCompare(b.text))?.map((client)  => {
                    const { text, value } = client;
                    const labelId = `checkbox-list-label-${value}`;
                    const isDisabled = editClient?.disabledClients?.includes(value);

                    return (
                      <ListItem
                        key={value}

                        disablePadding
                      >
                        <ListItemButton role={undefined} onClick={handleToggle(client)} dense disabled={isDisabled}>
                          <ListItemIcon >
                            <Checkbox
                              edge="start"
                              checked={checked?.indexOf(value) !== -1}
                              tabIndex={-1}
                              disableRipple
                              inputProps={{ 'aria-labelledby': labelId }}
                              disabled={isDisabled}
                            />
                          </ListItemIcon>
                          <ListItemText id={labelId} primary={<b>{text}</b>} />
                        </ListItemButton>
                      </ListItem>
                    );
                  })}
                </List>
              </Box>
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label3')}<span style={{ color: "red" }}>*</span>
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={registration}
                  onChange={(event) => setRegistration(event.target.value)}
                >
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="U. S."
                  />
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="International"
                  />
                </RadioGroup>

              </FormControl>
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label4')} <span style={{ color: "red" }}>*</span>
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "299px"
                }}
                value={name}
                onChange={(event) => setName(event.target.value)}
                required
                // error={!name}
                // helperText={!name && 'Name is required'} 
                size="small"
                id="outlined-name"
                fullWidth

              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label7')}<span style={{ color: "red" }}>*</span>
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 },
                  width: "299px"
                }}
                select
                required
                size='small'
                placeholder={t('Mycompany.country')}
                name="country"
                id="country"
                value={counrtyid || ""}
                className="form-control text-feild-custom "
                onChange={(e) => getState(e.target.value)}
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      style: {
                        maxHeight: 350, // Set the maximum height here
                      },
                    },
                  },
                }}
              >
                {countries?.map((item, index) => (
                  <MenuItem key={index} value={item.value}>
                    {item.value}
                  </MenuItem>
                ))}
              </TextField>

            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label8')}<span style={{ color: "red" }}>*</span>
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 },
                  width: "299px"
                }}
                select
                type="state"
                id='state'
                size='small'
                required
                name="state"
                value={stateid || ""}
                onChange={(e) => ChangeState(e.target.value)}
                placeholder={t('Mycompany.state')}
                className="form-control text-feild-custom "
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      style: {
                        maxHeight: 350, // Set the maximum height here
                      },
                    },
                  },
                }}
              >
                {states?.map((item, index) => (
                  <MenuItem key={index} value={item.value}>
                    {item.value}
                  </MenuItem>
                ))}
              </TextField>

            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label9')}<span style={{ color: "red" }}>*</span>
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "299px"
                }}
                value={City}
                onChange={(event) => setCity(event.target.value)}
                size="small"
                id="outlined-name"

              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label10')}<span style={{ color: "red" }}>*</span>
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "299px"
                }}
                value={Zip}
                onChange={(event) => setZip(event.target.value)}
                size="small"
                id="outlined-name"

              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label11')}<span style={{ color: "red" }}>*</span>
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "299px"
                }}
                value={Address}
                onChange={(event) => setAddress(event.target.value)}
                size="small"
                id="outlined-name"

              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label12')}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "299px"
                }}
                value={Address2}
                onChange={(event) => setAddress2(event.target.value)}
                size="small"
                id="outlined-name"

              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label13')}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "299px"
                }}
                value={Address3}
                onChange={(event) => setAddress3(event.target.value)}
                size="small"
                id="outlined-name"

              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label14')}<span style={{ color: "red" }}>*</span>
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              {/* <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "299px"
                }}
                value={Telephone}
                onChange={(event) => setTelephone(event.target.value)}
                size="small"
                id="outlined-name"

              /> */}
              <TextField
                sx={{
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 },
                  width: '299px',
                }}
                value={Telephone}
                onInput={handleInputChange}
                size="small"
                id="outlined-name"
                variant="outlined"
                error={telephoneError}
                helperText={telephoneError ? 'Invalid phone number format. Use (xxx) xxx-xxxx' : ''}
              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label15')}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 },
                  width: '299px',
                }}
                value={Phone}
                onChange={(event) => {
                  const inputValue = event.target.value;
                  const numericInput = inputValue.replace(/[^0-9]/g, '');

                  if (numericInput.length <= 10) {
                    if (numericInput === '') {
                      // Field is empty, no error
                      setPhone('');
                      setPhoneError(false);
                    } else if (/^\d{10}$/.test(numericInput)) {
                      const formattedInput = `(${numericInput.slice(0, 3)}) ${numericInput.slice(3, 6)}-${numericInput.slice(6)}`;
                      setPhone(numericInput);
                      setPhoneError(false);
                    } else {
                      setPhone(numericInput);
                      setPhoneError(true);
                    }
                  } else {
                    // Limit to 10 digits, no further input allowed
                    // setPhone(numericInput.slice(0, 10));
                    setPhone(numericInput);
                    setPhoneError(true);
                  }
                }}
                size="small"
                id="outlined-name"
                variant="outlined"
                error={phoneError}
                helperText={phoneError ? 'Use only number format' : ''}
              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label16')}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "299px"
                }}
                value={Fax}
                onChange={(event) => {
                  // const email = event.target.value;
                  // setFax(email);
                  // const isValid = validateNumber(email);
                  // setFaxError(!isValid);
                  const inputValue = event.target.value;
                  const numericInput = inputValue.replace(/[^0-9]/g, '');

                  if (numericInput.length <= 10) {
                    if (numericInput === '') {
                      // Field is empty, no error
                      setFax('');
                      setFaxError(false);
                    } else if (/^\d{10}$/.test(numericInput)) {
                      const formattedInput = `(${numericInput.slice(0, 3)}) ${numericInput.slice(3, 6)}-${numericInput.slice(6)}`;
                      setFax(formattedInput);
                      setFaxError(false);
                    } else {
                      setFax(numericInput);
                      setFaxError(true);
                    }
                  } else {
                    // Limit to 10 digits, no further input allowed
                    setFax(numericInput.slice(0, 10));
                    setFaxError(true);
                  }
                }}
                error={faxError}
                helperText={faxError ? 'Invalid Faxnumber format use (xxx) xxx-xxxx' : ''}
                size="small"
                id="outlined-name"

              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label17')}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                InputProps={{
                  startAdornment: <InputAdornment position="start" ><Box  >http:// </Box></InputAdornment>,
                }}
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "299px"
                }}
                value={url}
                onChange={(event) => setUrl(event.target.value)}
                size="small"
                id="outlined-name"
              />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={12} md={12}>
              {/* <div style={{float:"right", marginBottom:"10px"}}>
          <Button variant="contained"sx={{padding:"10px"}} onClick={handleSubmit}>{t('ClientEditBusinessInfo.label18')}</Button></div> */}

            </Grid>

          </Grid>



        </Box>
      </Box>
      <Box>
        <Box
          border={1}
          borderLeft={1}
          borderRight={1}
          borderColor="#e4e7ec"
          className="mt-5"
          sx={{ background: "#fff" }}
        >

          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                className="mt-2"
                style={{ fontSize: "500px", color: "#3E4A62", fontSize: "20px", fontWeight: "500", marginBottom: 0 }}
              >
                {t('ClientEditBusinessInfo.label19')}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}></Grid>
          </Grid>
          <hr hidden={org == "1"} />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
            hidden={org == "1"}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label20')}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={accpectVendor}
                  onChange={(event) => setAccpectVendor(event.target.value)}

                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="yes"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>

              </FormControl>

            </Grid>
          </Grid>
         
         <hr hidden={org == "1"||editClient?.organizationType!="Client"} />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
            hidden={org == "1"}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label22')}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "299px"
                }}
                value={TrainingFeeCap}
                
                onChange={(event) => setTrainingFeeCap(event.target.value)}
                size="small"
                id="outlined-name"

              />
            </Grid>
          </Grid>
          <hr hidden={org == "1"} />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
            hidden={org == "1"}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label23')}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={TrainingCertificate}
                  onChange={(event) => setTrainingCertificate(event.target.value)}

                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="yes"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>

              </FormControl>
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label24')}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <FormControl fullWidth>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={year}
                  label="Age"
                  onChange={handleChange1}
                  size="small"
                  fullWidth
                  sx={{

                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                    width: "299px"

                  }}
                >
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={2}>2</MenuItem>
                  <MenuItem value={3}>3</MenuItem>
                  <MenuItem value={4}>4</MenuItem>
                  <MenuItem value={5}>5</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <hr />

          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label26')}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "299px"
                }}
                value={RepresentativeName}
                onChange={(event) => setRepresentativeName(event.target.value)}
                size="small"
                id="outlined-name"

              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label27')}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 },
                  width: '299px',
                }}
                value={RepresentativeEmail}
                onChange={(event) => {
                  const email = event.target.value;
                  setRepresentativeEmail(email);
                  const isValid = validateEmail(email);
                  setEmailError(!isValid);
                }}
                size="small"
                id="outlined-name"
                variant="outlined"
                error={emailError}
                helperText={emailError ? 'Invalid email format' : ''}
              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label28')}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "299px"
                }}
                value={InfusionSoftContactID}
                onChange={(event) => setInfusionSoftContactID(event.target.value)}
                size="small"
                id="outlined-name"

              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label29')}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={3}>
              <div {...getRootProps({ style })} className="drop">
                <img className='mt-2' src={Logo} alt="" />
                <br />
                <input {...getInputProps()} />

                <span className='text-muted mt-2 fs'><b><span className='mx-1 cl'>{t('DragandDrop.firstLabel1')}</span>
                  { }</b></span>
                <br />
                <span className=' text-muted Fs'>
                  {t('Only Png Allowed')}
                  <br />
                </span>
                <span className=' text-muted Fs'> {acceptedFileItems}</span>
              </div>
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {/* {t('ClientEditBusinessInfo.label30')} */}
                Select Photo
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={3}>
              <div {...getRootProps2({ style })} className="drop">
                <img className='mt-2' src={Logo} alt="" />
                <br />
                <input {...getInputProps2()} />
                <span className='text-muted mt-2 fs'>
                  <b><span className='mx-1 cl'>{t('DragandDrop.firstLabel1')}</span></b>
                </span>
                <br />
                <span className=' text-muted Fs'>
                  {t('Only Png Allowed')}
                  <br />
                </span>
                <span className=' text-muted Fs'> {acceptedFileItems2}</span>



              </div>
            </Grid>
          </Grid>
          <hr hidden={org == "1"} />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
            hidden={org == "1"}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {"Client Id"}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={3}>
              {editClient?.organizationID}
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}

          >
            <hr />
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {"Employee Self Registration URL:"}
              </p>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <a href={"/EmpSelfRegistration?clientcode=" + editClient?.singleClientCode} target="_blank" rel="noopener noreferrer">{window.location.origin+"/EmpSelfRegistration?clientcode="+ editClient?.singleClientCode}</a>
            </Grid></Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
            hidden={org == "1"}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {"Client Code:"}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={3}>
              {editClient?.singleClientCode}
            </Grid>

            <Grid item xs={2} sm={4} md={3}>
              <Button variant="contained" sx={{ padding: "15px" }} onClick={() => handleClickOpen(1, "")} >Generate Keys</Button>
            </Grid>
          </Grid>

          <hr />

          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
            hidden={org == "1"}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {"Client Secret:"}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={3}>
              {ClientSecrte}
            </Grid>

            <Grid item xs={2} sm={4} md={3}>
              <IconButton aria-label="delete" onClick={() => NewClientsecret()}>
                <img src={Replay} alt="Replay" />
              </IconButton>
            </Grid>
          </Grid>

          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={12} md={12}>
              <div style={{ float: "right", marginBottom: "10px" }}>
                <Button variant="contained" sx={{ padding: "10px" }} onClick={handleSubmit} disabled={phoneError || telephoneError || emailError || faxError}>{t('ClientEditBusinessInfo.label18')}</Button></div>
            </Grid>

          </Grid>
        </Box>
      </Box>
    </>
  );
}
